export const DataStoreTypes = {
  Keyed: "keyed",
  Keyless: "keyless"
};
